var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTFailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6971 119.374C40.2713 106.38 29.7568 80.4075 22.1542 84.2935C14.5516 88.1795 31.641 107.385 36.2395 121.092",
    fill: "url(#paint0_linear_1_31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M26.107 89.5806C26.107 89.5806 35.5807 108.244 36.3844 114.893",
    stroke: "url(#paint1_linear_1_31)",
    strokeWidth: 0.667373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0529 117.906C33.2748 109.91 8.89906 96.2292 5.38104 104.028C1.86303 111.826 27.1743 116.109 39.3095 123.92",
    fill: "url(#paint2_linear_1_31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M10.0717 105.931C19.4136 108.654 36.9378 118.541 36.9378 118.541",
    stroke: "url(#paint3_linear_1_31)",
    strokeWidth: 0.667373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55307 131.455C9.1002 134.164 50.987 129.604 52.5023 132.3C54.0175 134.997 29.958 133.992 24.2395 134.838C18.5211 135.671 17.5197 143.945 30.3005 143.602C43.0814 143.271 59.9072 141.751 58.2207 144.791C56.5341 147.831 41.5661 146.139 42.2381 151.704C42.9101 157.282 74.3614 155.762 92.0305 155.921C109.687 156.092 114.404 150.025 100.608 148.505C86.8128 146.985 77.2206 146.139 82.7941 144.448C88.3544 142.769 144.84 147.316 143.668 139.729C142.495 132.129 123.653 137.865 125.498 134.666C127.356 131.455 154.261 135.512 155.948 127.912C156.633 124.819 134.813 123.445 107.881 122.903C86.3517 122.48 61.5674 122.599 42.3698 122.837C26.5454 123.022 14.5288 123.299 11.2874 123.392C-0.821397 123.749 -1.99407 128.758 3.55307 131.455Z",
    fill: "url(#paint4_linear_1_31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2381 124.066C42.9101 129.63 74.3614 128.11 92.0306 128.282C104.851 128.401 110.859 125.229 107.881 122.903C86.3517 122.48 61.5674 122.599 42.3698 122.837C42.2381 123.193 42.1854 123.603 42.2381 124.066Z",
    fill: "url(#paint5_linear_1_31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5981 43.397H2.9082C3.01361 38.8104 7.69113 37.7795 8.74521 40.3834C9.65437 36.8806 11.9734 35.6778 13.8971 35.9158C14.6086 34.3693 15.6495 33.1004 16.8617 32.4791C19.9449 30.9062 24.9386 32.2016 26.6252 38.784C28.2458 34.7922 35.4268 36.3652 35.5981 43.397Z",
    fill: "url(#paint6_linear_1_31)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5303 11.522H124.22C124.115 6.93544 119.437 5.90446 118.383 8.50836C117.474 5.00565 115.155 3.80283 113.231 4.04075C112.52 2.49427 111.479 1.22536 110.267 0.604127C107.183 -0.968789 102.19 0.326554 100.503 6.90901C98.8825 2.91724 91.7016 4.49015 91.5303 11.522Z",
    fill: "url(#paint7_linear_1_31)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.117 52.9675L35.7929 43.2343L45.4614 42.908L45.7854 52.6413L36.117 52.9675ZM36.658 44.049L36.9263 52.0966L44.9203 51.8266L44.6521 43.779L36.658 44.049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.303 56.0621C134.303 57.337 133.276 58.3702 132.01 58.3702C130.744 58.3702 129.718 57.3366 129.718 56.0621C129.718 54.7876 130.744 53.7539 132.01 53.7539C133.277 53.7539 134.303 54.7876 134.303 56.0621Z",
    fill: "#EC6750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6206 39.5887C58.6206 41.2798 57.2585 42.6515 55.5782 42.6515C53.8978 42.6515 52.5361 41.2803 52.5361 39.5887C52.5361 37.8971 53.8983 36.5258 55.5782 36.5258C57.2581 36.5258 58.6206 37.8971 58.6206 39.5887Z",
    fill: "#EC6750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.492 39.4291L107.324 40.0796L113.746 41.7649L113.915 41.1144L107.492 39.4291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.138 37.2812L109.463 43.7466L110.109 43.9163L111.784 37.4509L111.138 37.2812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.159 50.0813C121.225 49.8079 119.06 47.1828 119.331 44.2299C119.603 41.2765 122.211 39.0964 125.144 39.3698C128.078 39.6432 130.243 42.2683 129.972 45.2217C129.7 48.1751 127.092 50.3551 124.159 50.0817L124.159 50.0813ZM125.071 40.1642C122.573 39.9314 120.352 41.7882 120.121 44.3034C119.89 46.8186 121.734 49.054 124.232 49.2869C126.731 49.5197 128.951 47.6629 129.183 45.1477C129.414 42.6325 127.569 40.3971 125.071 40.1642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8329 37.7855L32.3752 111.013C28.7509 116.851 32.7147 124.612 39.3152 124.603C104.698 124.519 80.3364 124.606 130.227 124.621C136.824 124.623 140.78 116.866 137.158 111.031L91.689 37.7855C88.4148 32.5109 81.1071 32.5109 77.8325 37.7855H77.8329Z",
    fill: "#FE5A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2378 106.228C80.2378 103.433 82.1657 101.414 84.788 101.414C87.5644 101.414 89.3383 103.433 89.3383 106.228C89.3383 109.023 87.5644 111.041 84.788 111.041C82.0117 111.041 80.2378 108.945 80.2378 106.228ZM82.1368 94.1174L81.1172 58.9271C81.1004 58.3423 81.5667 57.8589 82.1481 57.8589H87.4284C88.0097 57.8589 88.4761 58.3423 88.4593 58.9271L87.4397 94.1174C87.4233 94.6786 86.9666 95.1252 86.4087 95.1252H83.1677C82.6099 95.1252 82.1531 94.6786 82.1368 94.1174Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 21.3308,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7232 37.8937L32.444 114.659C29.3125 120.779 33.901 128.183 40.4779 127.624C105.629 122.091 81.3585 124.208 131.079 120.065C137.653 119.517 140.959 111.456 136.869 105.943L85.5318 36.7388C81.835 31.7553 74.5524 32.3643 71.7232 37.8937Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7487 105.901C79.5187 103.115 81.2742 100.943 83.8872 100.724C86.6539 100.493 88.5877 102.357 88.8178 105.142C89.0411 107.85 87.446 110.087 84.6793 110.318C81.9894 110.543 79.9725 108.608 79.7487 105.901ZM80.6449 93.6737L76.7348 58.6892C76.6697 58.1078 77.095 57.5872 77.6742 57.5386L82.9364 57.0987C83.5157 57.0501 84.0203 57.4929 84.0513 58.0773L85.9294 93.2317C85.9592 93.7924 85.5411 94.2754 84.9849 94.3219L81.7548 94.5919C81.199 94.6384 80.707 94.2315 80.6445 93.6737H80.6449Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_31",
    x1: 25.4509,
    y1: 78.3232,
    x2: 39.3558,
    y2: 133.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_31",
    x1: 34.8112,
    y1: 99.1372,
    x2: 27.6947,
    y2: 105.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_31",
    x1: 0.622263,
    y1: 104.559,
    x2: 72.192,
    y2: 127.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_31",
    x1: 28.3469,
    y1: 108.027,
    x2: 18.6616,
    y2: 116.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_31",
    x1: 98.5,
    y1: 232.689,
    x2: 61.6203,
    y2: 43.7718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_31",
    x1: 82.7019,
    y1: 75.7284,
    x2: 74.2435,
    y2: 131.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_31",
    x1: 17.2043,
    y1: 5.79242,
    x2: 20.1346,
    y2: 59.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_31",
    x1: 109.924,
    y1: -26.0826,
    x2: 106.981,
    y2: 27.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 95,
    fill: "white",
    transform: "translate(31 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTFailed);
export default __webpack_public_path__ + "static/media/t-failed.a75d8630bc4387cfa909a9590921bf3e.svg";
export { ForwardRef as ReactComponent };